import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loader from 'components/Loader';
import { useAppDispatch, useAppSelector } from 'helpers/hooks';
import HeaderAndFooterLayout from 'layouts/HeaderAndFooter';
import { NotFoundScreen } from 'screens/NotFound';
import { getSitewideConfig } from 'selectors/siteConfig';
import { getSiteConfig } from 'store/siteConfig/actions';
import { localizedDate } from 'helpers/date';
import { noop, sanitizeHtml } from 'helpers/utils';

export type PostDetails = {
  query_str: string;
  title: string;
  subheader: string;
  date: string;
  content: string;
};

export const PostScreen = () => {
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: string }>();
  const [postConfig, setPostConfig] = useState<PostDetails | null>(null);
  const sitewideConfig = useAppSelector(state => getSitewideConfig(state, 'posts'));

  useEffect(() => {
    dispatch(getSiteConfig()).catch(noop);
  }, []);

  useEffect(() => {
    if (id && sitewideConfig?.posts?.find(post => post.query_str === id)) {
      setPostConfig(sitewideConfig.posts?.find(post => post.query_str === id));
    }
  }, [sitewideConfig]);

  if (!id || (sitewideConfig && !sitewideConfig.posts?.find(post => post.query_str === id))) {
    return <NotFoundScreen />;
  }

  if (!sitewideConfig) {
    return (
      <HeaderAndFooterLayout headerVisible={true} footerVisible={true} isLoading={true}>
        <div className="loader-center">
          <Loader width={60} height={60} />
        </div>
      </HeaderAndFooterLayout>
    );
  }

  return (
    <HeaderAndFooterLayout
      headerVisible={true}
      footerShowSupportCta={true}
      isLoading={false}
      hasIssues={true}
    >
      <div className="posts-container">
        <div className="posts-content">
          <span className="h2-dtm mb10">{postConfig?.title}</span>
          {postConfig?.subheader && <span className="h4-text mb10">{postConfig.subheader}</span>}
          <span className="h4-text">{localizedDate(postConfig?.date)}</span>
          <div
            className="body-text"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(postConfig?.content) }}
          />
        </div>
      </div>
    </HeaderAndFooterLayout>
  );
};
